import register from '../_internal/GraphShapeRegistration';
export * from './GraphBuilder';
register();